import { AfterViewInit, Component, forwardRef, HostBinding, Inject, Input, OnChanges, OnDestroy, OnInit, Optional, SimpleChanges } from "@angular/core";
import { PageTitleComponent } from "../page-title/page-title.component";
import "./page-title-pill.component.scss";

@Component({
    selector: "page-title-pill",
    template: require("./page-title-pill.component.html")
})
export class PageTitlePillComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {

    @Input() icon: string;
    @Input() valid: boolean;
    @Input() warning: boolean;

    // ---

    @HostBinding("class.valid") validClass = false;
    @HostBinding("class.invalid") invalidClass = false;
    @HostBinding("class.warning") warningClass = false;

    fontAwesome = false;

    constructor(@Optional() @Inject(forwardRef(() => PageTitleComponent)) private parent: PageTitleComponent) {
    }

    ngOnInit(): void {
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes["valid"] || changes["warning"]) {
            this.setValidClass();
        }

        if (this.icon?.indexOf("fa-") == 0) {
            this.fontAwesome = true;
        }
    }

    ngAfterViewInit() {
        this.parent?.onPillAdded(this);
    }

    ngOnDestroy() {
        this.parent?.onPillRemoved(this);
    }

    // ---

    private setValidClass() {
        this.validClass = false;
        this.invalidClass = false;

        if (this.valid) {
            this.validClass = true;
        }
        else if (this.valid === false) {
            this.invalidClass = true;
        }

        this.warningClass = this.warning;
    }
}
